export default {
	"6e5998108827d7090342f60ce5ed12d1": "No payment result was detected",
	"df2c8aec0bfb103dfa35c521cd09c123": "If payment has been made, please click \"Refresh\" to check the result",
	"9e515b60501b2753783c75ed0438b233": "Refresh",
	"17889ebd5ded84c80621a617c129a1d3": "Re-payment"
}
